import { z } from "zod";

/**
 * Shared pieces of the two-phase spreadsheet uploads (customer product
 * mappings, Discounts v2 price lists, exception price list overlays): the
 * caller may name the worksheet to read; the preview echoes every sheet name
 * plus the one it actually read so the UI can offer a sheet picker.
 */
export const SheetNameInputSchema = z.string().min(1).optional();

export const WorkbookSheetsResponseFields = {
  /** Every worksheet in the workbook, in file order. */
  sheetNames: z.array(z.string()),
  /** The worksheet the preview was read from (the first, unless picked). */
  sheetName: z.string(),
} as const;
